<template>
  <div class="engagement-locked" data-qid="engagement-locked-notice">
    <font-awesome-icon icon="lock" class="engagement-locked__icon"/>
    <div>
      <div class="engagement-locked__title">{{ $t('projects.engagement.locked.title') }}</div>
      <div class="engagement-locked__message">{{ $t('projects.engagement.locked.message') }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'EngagementLockedNotice'
}
</script>
